export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
        layout: 'auth'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
    meta: {
        layout: 'auth'
    }
  },
  {
    path: '/reset-password',
    name: 'ForgetPassword',
    component: () => import('@/views/auth/ForgetPassword.vue'),
    meta: {
        layout: 'auth'
    }
  },
  {
    path: '/forget-password',
    name: 'ResetPassword',
    component: () => import('@/views/auth/ResetPassword.vue'),
    meta: {
        layout: 'auth'
    }
  },
  {
    path: '/staff-register',
    name: 'StaffRegister',
    component: () => import('@/views/auth/StaffRegister.vue'),
    meta: {
        layout: 'auth'
    }
  }
]